import { styled } from "styled-components";

export const CenteredContainer = styled.div`
  width: fit-content;
  margin: auto;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  align-items: center;
  padding-top: ${({ theme }) => theme.PADDING.LG};
  gap: ${({ theme }) => theme.PADDING.MD};
`;
